import React from "react";
import PropTypes from "prop-types";
import { graphColors } from "utils/styles";
import { Pie, PieChart, Tooltip, ResponsiveContainer } from "recharts";

const TaskTypeChart = ({ taskTypeBreakdown }) => {
  if (!taskTypeBreakdown || Object.keys(taskTypeBreakdown).length === 0) {
    return (
      <div className="graph-container">
        <h4 className="graph-header">Tasks Created</h4>
        <div style={{ textAlign: "center", padding: "40px", color: "#888" }}>
          No task data available
        </div>
      </div>
    );
  }

  const data = Object.entries(taskTypeBreakdown).map(([key, value], i) => ({
    label: key,
    value,
    fill: graphColors[i % graphColors.length]
  }));

  return (
    <div className="graph-container">
      <h4 className="graph-header">Tasks Created</h4>
      <ResponsiveContainer height={250}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            isAnimationActive={false}
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
        {data.map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div style={{ width: "12px", height: "12px", backgroundColor: item.fill, borderRadius: "2px" }} />
            <span style={{ fontSize: "12px" }}>{item.label}: {item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

TaskTypeChart.propTypes = {
  taskTypeBreakdown: PropTypes.object
};

export default TaskTypeChart;
